import React, { useState } from 'react';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, } from '@cargomatic/ui';
import { ChevronDown } from 'lucide-react';
import { FilterDateRange } from '../molecules/FilterDateRange';
import { useFilterChipPopover } from '../molecules/FilterChip';
/**
 * Shared date range filter organism.
 * Wrap with FilterGroup at the page level.
 */
export function DateRangeFilter({ value, onChange }) {
    return React.createElement(FilterDateRange, { value: value, onChange: onChange });
}
export function DateRangeWithTypeFilter({ typeOptions, value, onChange, }) {
    var _a, _b, _c;
    // Stage edits locally — match v1 DateRangeFilter which only propagates on
    // explicit Apply. Popover content unmounts on close, so staged state
    // resets to current `value` on each open (closes without Apply = cancel).
    const [staged, setStaged] = useState(value);
    const popover = useFilterChipPopover();
    const selectedLabel = ((_a = typeOptions.find((o) => o.value === staged.type)) === null || _a === void 0 ? void 0 : _a.label) ||
        ((_b = typeOptions[0]) === null || _b === void 0 ? void 0 : _b.label) ||
        '';
    const hasRange = Boolean(staged.from && staged.to);
    const handleApply = () => {
        onChange(staged);
        popover === null || popover === void 0 ? void 0 : popover.close();
    };
    const handleClear = () => {
        var _a, _b;
        const cleared = {
            from: null,
            to: null,
            type: (_b = (_a = typeOptions[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : staged.type,
        };
        setStaged(cleared);
        onChange(cleared);
        popover === null || popover === void 0 ? void 0 : popover.close();
    };
    return (React.createElement("div", { className: "space-y-2" },
        React.createElement(DropdownMenu, null,
            React.createElement(DropdownMenuTrigger, { asChild: true },
                React.createElement(Button, { variant: "outline", size: "sm", className: "w-full justify-between font-normal h-8" },
                    React.createElement("span", null, selectedLabel),
                    React.createElement(ChevronDown, { className: "size-3 opacity-50" }))),
            React.createElement(DropdownMenuContent, { align: "start", style: { minWidth: 'var(--radix-dropdown-menu-trigger-width)' } }, typeOptions.map((opt) => (React.createElement(DropdownMenuItem, { key: opt.value, onClick: () => setStaged((s) => (Object.assign(Object.assign({}, s), { type: opt.value }))) }, opt.label))))),
        React.createElement(FilterDateRange, { value: staged.from
                ? { from: staged.from, to: (_c = staged.to) !== null && _c !== void 0 ? _c : undefined }
                : undefined, onChange: (range) => setStaged((s) => {
                var _a, _b;
                return (Object.assign(Object.assign({}, s), { from: (_a = range === null || range === void 0 ? void 0 : range.from) !== null && _a !== void 0 ? _a : null, to: (_b = range === null || range === void 0 ? void 0 : range.to) !== null && _b !== void 0 ? _b : null }));
            }) }),
        React.createElement("div", { className: "flex justify-end gap-2 pt-1" },
            React.createElement(Button, { variant: "ghost", size: "sm", className: "h-8", onClick: handleClear }, "Clear"),
            React.createElement(Button, { size: "sm", className: "h-8", onClick: handleApply }, hasRange ? 'Update date filter' : 'Add date filter'))));
}
